import { render } from "./QrReader.vue?vue&type=template&id=4b49f8fc&scoped=true"
import script from "./QrReader.vue?vue&type=script&lang=js"
export * from "./QrReader.vue?vue&type=script&lang=js"

import "./QrReader.vue?vue&type=style&index=0&id=4b49f8fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b49f8fc"]])

export default __exports__